import { render } from "./HeaderNavigation.vue?vue&type=template&id=81c89818&scoped=true"
import script from "./HeaderNavigation.vue?vue&type=script&lang=js"
export * from "./HeaderNavigation.vue?vue&type=script&lang=js"

import "./HeaderNavigation.vue?vue&type=style&index=0&id=81c89818&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-81c89818"]])

export default __exports__